import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link, Redirect } from 'react-router-dom';

import moment from 'moment';

import Autosuggest from 'react-autosuggest';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

import Files from 'react-files';

import { 
  loadEvents,
  loadEvent,
  addEvent,
  editEvent,
} from '../../reducers/events';

import update from 'immutability-helper';

import axios from 'axios';

class EventEditor extends Component {

  state = {
    id: null,
    mode: null,
    added: false,
    edited: false,
    permission: 'Allowed',
    event: {
      event_title: '',
      description: '',
    },
    event_timestart: moment().hour(8).minute(0),
    event_datestart: moment().format('YYYY-MM-DD'),
    event_timeend: moment().hour(17).minute(0),
    event_dateend: moment().format('YYYY-MM-DD'),
    stores: [],
    storesSuggestions: [],
    eventImageEvent: null,
    eventImageEventSrc: null,
    isEditingEventImage: false,
    eventImageEventTwo: null,
    eventImageEventTwoSrc: null,
    isEditingEventImageTwo: false,
    eventImageEventThree: null,
    eventImageEventThreeSrc: null,
    isEditingEventImageThree: false,
    errors: {
      event_title: null,
      event_datetime: null,
      description: null,
    },
    canAdd: false,
    canEdit: false,
  }

  componentDidMount = () => {

    window.scrollTo(0, 0);
    
    if (!isNaN(parseInt(this.props.match.params.id, 10))) {
      this.setState({mode: 'Edit', id: parseInt(this.props.match.params.id, 10)});
    } else {
      this.setState({mode: 'Add'});
    }

    this.mapStoresSuggestions();

  }

  componentDidUpdate = (prevProps, prevState) => {
    if(this.state.mode === 'Add' && prevState.mode !== this.state.mode) {
    }
    if(this.state.mode === 'Edit' && prevState.mode !== this.state.mode) {
      this.loadEventByID();
    }
    if(!this.props.isLoadingStores && prevProps.isLoadingStores !== this.props.isLoadingStores) {
      this.mapStoresSuggestions();
    }
  }

  loadEventByID = () => {
    if(this.state.id){
      this.props.loadEvent(this.state.id, (resp) => {
        if(resp.data) {
          this.setState({event: resp.data.events}, ()=> {
            
            this.setState(update(this.state, { event: { removeImage: {$set: [false, false, false]} }}), ()=> {
              this.mapEventToFields();
            });
          });
          this.validateFields();
        } else {
          this.setState({permission: 'Disallowed'});
        }
      });
    }
  }

  mapEventToFields = () => {
    this.mapStores();
    this.mapEventDateTimes();
    this.mapEventImage();
  }

  mapStores = () => {
    
    if(this.state.event.stores) {
      let removeStore = [];
      const stores = this.state.event.stores.map((store) => {
        removeStore.push(true); //remove all
        return {id: String(store.store_id), text: store.store_name};
      });
      this.setState(update(this.state, {stores:{$set: stores}, event:{removeStore:{$set: removeStore}}}, ()=> {
        this.validateFields();
      }));
    }

  }

  mapStoresSuggestions = () => {
    let storesSuggestions = this.props.stores.map((store) => {
      return {id: String(store.store_id), text: store.store_name};
    });
    
    this.setState({storesSuggestions});
  }

  mapEventDateTimes = () => {
    let event_datestart = moment(this.state.event.schedule.date_start).utc().format('YYYY-MM-DD');
    let event_dateend = moment(this.state.event.schedule.date_end).utc().format('YYYY-MM-DD');
    let event_timestart = moment(this.state.event.schedule.date_start).utc();
    let event_timeend = moment(this.state.event.schedule.date_end).utc();

    this.setState({event_datestart, event_dateend, event_timestart, event_timeend}, ()=> {
      this.validateFields();
    });
  }

  mapEventImage = () => {
    if(this.state.event.medias.length > 0){
      if(this.state.event.medias[0]){
        axios.get(this.state.event.medias[0].media).then((resp) => {
          const event = new File([resp.data], this.state.event.medias[0].media.split('/').pop(), {type: "image/*"});
          this.setState({eventImageEvent: event, eventImageEventSrc: this.state.event.medias[0].media});
        });
      }
      if(this.state.event.medias[1]){
        axios.get(this.state.event.medias[1].media).then((resp) => {
          const event = new File([resp.data], this.state.event.medias[1].media.split('/').pop(), {type: "image/*"});
          this.setState({eventImageEventTwo: event, eventImageEventTwoSrc: this.state.event.medias[1].media});
        });
      }
      if(this.state.event.medias[2]){
        axios.get(this.state.event.medias[2].media).then((resp) => {
          const event = new File([resp.data], this.state.event.medias[2].media.split('/').pop(), {type: "image/*"});
          this.setState({eventImageEventThree: event, eventImageEventThreeSrc: this.state.event.medias[2].media});
        });
      }
    }
  }

  handleEventTitleChange = (e) => {
    this.setState(update(this.state, {event: {event_title: {$set: e.target.value}}}), () => {

      if(this.state.event.event_title.length === 0) {
        this.setState(update(this.state, {errors: {event_title: {$set: 'Event title must not be empty'}}}));
      } else if( this.state.event.event_title.length > 0) {
        this.setState(update(this.state, {errors: {event_title: {$set: null}}}));
      }

      this.validateFields();
    });
  }

  handleStoreChange = (stores) => {
    this.setState({stores}, () => {

      this.validateFields();
    })
  }

  handleEventDescriptionChange = (e) => {
    this.setState(update(this.state, {event: {description: {$set: e.target.value}}}), () => {

      if(this.state.event.description.length === 0) {
        this.setState(update(this.state, {errors: {description: {$set: 'Event description must not be empty'}}}));
      } else if( this.state.event.description.length > 0) {
        this.setState(update(this.state, {errors: {description: {$set: null}}}));
      }

      this.validateFields();
    });
  }

  handleEventDateTimeChange() {

    let event_datetimestart = moment();
    event_datetimestart.minute(this.state.event_timestart.minute());
    event_datetimestart.hour(this.state.event_timestart.hour());
    event_datetimestart.date(this.state.event_datestart.split("-")[2]);
    event_datetimestart.month(this.state.event_datestart.split("-")[1] - 1);
    event_datetimestart.year(this.state.event_datestart.split("-")[0]);

    let event_datetimeend = moment();
    event_datetimeend.minute(this.state.event_timeend.minute());
    event_datetimeend.hour(this.state.event_timeend.hour());
    event_datetimeend.date(this.state.event_dateend.split("-")[2]);
    event_datetimeend.month(this.state.event_dateend.split("-")[1] - 1);
    event_datetimeend.year(this.state.event_dateend.split("-")[0]);

    if(event_datetimestart.isSameOrAfter(event_datetimeend, 'minute')) {
      this.setState(update(this.state, {errors: {event_datetime: {$set: 'Event date/time start must be before Event date/time end'}}}), () => {
        this.validateFields();
      });
    } else {
      this.setState(update(this.state, {errors: {event_datetime: {$set: null}}}), () => {
        this.validateFields();
      });
    }

  }

  handleEventImageChange = (event) => {
    if(event.length){
      this.setState({eventImageEvent: event[0]}, () => { } );
      const reader  = new FileReader();
  
      reader.onload = (e) => {
        this.setState({eventImageEventSrc: e.target.result, isEditingEventImage: true});
      };
      reader.readAsDataURL(event[0]);
    }
  }

  handleEventImageChangeError = (error, event) => {
    window.alert(`${error.message}`);
  }

  removeEventImage = () => {
    this.setState(update(this.state, { eventImageEvent: {$set: null}, eventImageEventSrc: {$set: null}, event: { removeImage: {[0]: {$set: true}}}}));
  }

  handleEventImageTwoChange = (event) => {
    if(event.length){
      this.setState({eventImageEventTwo: event[0]}, () => { } );
      const reader  = new FileReader();
  
      reader.onload = (e) => {
        this.setState({eventImageEventTwoSrc: e.target.result, isEditingEventImageTwo: true});
      };
      reader.readAsDataURL(event[0]);
    }
  }

  handleEventImageTwoChangeError = (error, event) => {
    window.alert(`${error.message}`);
  }

  removeEventImageTwo = () => {
    this.setState(update(this.state, { eventImageEventTwo: {$set: null}, eventImageEventTwoSrc: {$set: null}, event: { removeImage: {[1]: {$set: true}}}}));
  }

  handleEventImageThreeChange = (event) => {
    if(event.length){
      this.setState({eventImageEventThree: event[0]}, () => { } );
      const reader  = new FileReader();
  
      reader.onload = (e) => {
        this.setState({eventImageEventThreeSrc: e.target.result, isEditingEventImageThree: true});
      };
      reader.readAsDataURL(event[0]);
    }
  }

  handleEventImageThreeChangeError = (error, event) => {
    window.alert(`${error.message}`);
  }

  removeEventImageThree = () => {
    this.setState(update(this.state, { eventImageEventThree: {$set: null}, eventImageEventThreeSrc: {$set: null}, event: { removeImage: {[2]: {$set: true}}}}));
  }

  addEvent = () => {
    
    const event = Object.assign({}, this.state.event);
    event.schedule = {
      "date_start": moment().year(this.state.event_datestart.split("-")[0]).month(this.state.event_datestart.split("-")[1] - 1).date(this.state.event_datestart.split("-")[2]).hour(this.state.event_timestart.hour()).minute(this.state.event_timestart.minute()).format('YYYY-MM-DDTHH:mm') + ':00.000Z',
      "date_end": moment().year(this.state.event_dateend.split("-")[0]).month(this.state.event_dateend.split("-")[1] - 1).date(this.state.event_dateend.split("-")[2] ).hour(this.state.event_timeend.hour()).minute(this.state.event_timeend.minute()).format('YYYY-MM-DDTHH:mm') + ':00.000Z'
    };

    event.stores = this.state.stores.map((store) => {
      return {'store_id': store.id};
    })

    const data = new FormData()
    data.append('data', JSON.stringify(event));

    if(this.state.isEditingEventImage){
      data.append('file', this.state.eventImageEvent);
    }

    if(this.state.isEditingEventImageTwo){
      data.append('file', this.state.eventImageEventTwo);
    }

    if(this.state.isEditingEventImageThree){
      data.append('file', this.state.eventImageEventThree);
    }

    this.props.addEvent(data, (resp) => {
      this.setState({added: true});
      this.props.loadEvents();
    });
  }

  editEvent = () => {
    
    const event = Object.assign({}, this.state.event);
    event.schedule = {
      "date_start": moment().year(this.state.event_datestart.split("-")[0]).month(this.state.event_datestart.split("-")[1] - 1).date(this.state.event_datestart.split("-")[2]).hour(this.state.event_timestart.hour()).minute(this.state.event_timestart.minute()).format('YYYY-MM-DDTHH:mm') + ':00.000Z',
      "date_end": moment().year(this.state.event_dateend.split("-")[0]).month(this.state.event_dateend.split("-")[1] - 1).date(this.state.event_dateend.split("-")[2]).hour(this.state.event_timeend.hour()).minute(this.state.event_timeend.minute()).format('YYYY-MM-DDTHH:mm') + ':00.000Z'
    };

    event.stores = this.state.stores.map((store) => {
      return {'store_id': store.id};
    })

    const data = new FormData()

    if(this.state.isEditingEventImage){
      data.append('file', this.state.eventImageEvent);
    }

    if(this.state.isEditingEventImageTwo){
      data.append('file', this.state.eventImageEventTwo);
    }

    if(this.state.isEditingEventImageThree){
      data.append('file', this.state.eventImageEventThree);
    }

    data.append('data', JSON.stringify(event));

    this.props.editEvent(this.state.id, data, (resp) => {
      this.setState({edited: true});
      this.props.loadEvents();
    });
  }

  validateFields = () => {
    let flag = true;

    if(this.state.event.event_title.length === 0) {
      flag = false;
    } else if( this.state.event.event_title.length > 0) {
    }


    if(this.state.event.description.length === 0) {
      flag = false;
    } else if( this.state.event.description.length > 0) {
    }

    if(this.state.errors.event_datetime) {
      flag = false;
    } else {
    }


    if(flag) {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: true});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: true});
      }
    } else {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: false});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: false});
      }
    }

  }

  render() {

    if (this.state.permission !== 'Allowed' || this.state.added || this.state.edited) {
      return <Redirect to='/events'/>;
    }

    this.autocompleteRenderStoreInput = ({addTag, ...props}) => {
      const handleOnChange = (e, {newValue, method}) => {
        if (method === 'enter') {
          e.preventDefault()
        } else {
          props.onChange(e)
        }
      }

      const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
      const inputLength = inputValue.length

      let suggestions = this.state.storesSuggestions.filter((store) => {
        const storeIDs = this.state.stores.map((store) => { return store.id; });
        return store.text.toLowerCase().slice(0, inputLength) === inputValue && storeIDs.indexOf(store.id) === -1;
      })

      return (
        <Autosuggest
          ref={props.ref}
          suggestions={suggestions}
          shouldRenderSuggestions={(value) => value && value.trim().length > 0}
          getSuggestionValue={(suggestion) => suggestion.text}
          renderSuggestion={(suggestion) => <span className="btn btn-light">{suggestion.text}</span>}
          inputProps={{...props, onChange: handleOnChange}}
          onSuggestionSelected={(e, {suggestion}) => {
            addTag(suggestion)
          }}
          onBlur={() => {return false;}}
          onSuggestionsClearRequested={() => {}}
          onSuggestionsFetchRequested={() => {}}
        />
      )
    }

    this.renderStoreTag = (props) => {
      let {tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other} = props
      return (
        <span key={key} {...other} className={`btn btn-primary btn-tag`} onClick={(e) => onRemove(key)}>
          {getTagDisplayValue(tag.text)}
        </span>
      )
    }

    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>{this.state.mode === 'Add' ? 'Add' : ''}{this.state.mode === 'Edit' ? 'Edit' : ''} Event</PageTitle>

          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/events'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addEvent} disabled={this.props.isAddingEvent || !this.state.canAdd} >Add Event</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editEvent} disabled={this.props.isEditingEvent || !this.state.canEdit} >Edit Event</button>
                }
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Event Details</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="eventName">Event Title *</label>
                    <input type="text" className="form-control" id="eventName" value={this.state.event.event_title} onChange={this.handleEventTitleChange} placeholder="Event Title" autoFocus />
                    {this.state.errors.event_title &&
                      <small id="eventNameError" className="form-text text-muted">{this.state.errors.event_title}</small>
                    }
                  </div>
                  <div className="form-group">
                    <label htmlFor="store">Event Point of Interest(s)</label>
                    <TagsInput renderInput={this.autocompleteRenderStoreInput} renderTag={this.renderStoreTag} value={this.state.stores} onChange={this.handleStoreChange} inputProps={{placeholder: 'Add a Point of Interest'}} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="eventDescription">Event Description *</label>
                    <textarea className="form-control" id="eventDescription" rows="3" value={this.state.event.description} onChange={this.handleEventDescriptionChange} ></textarea>
                    {this.state.errors.description &&
                      <small id="eventDescriptionError" className="form-text text-muted">{this.state.errors.description}</small>
                    }
                  </div>
                  <div className="form-group">
                    <label>Event Date/Time Start *</label>
                    <div className="row">
                      <div className="col">
                        <input type="date" className="form-control input-group-field" name="birthdate" id="birthdate" value={this.state.event_datestart}
                          onChange={event => this.setState({event_datestart: event.target.value}, () => { this.handleEventDateTimeChange(); } )} />
                      </div>
                      <div className="col">
                        <TimePicker showSecond={false} value={moment(this.state.event_timestart, "YYYY-MM-DD hh:mm:ss")} 
                          onChange={(e) => this.setState({event_timestart: e}, () => { this.handleEventDateTimeChange(); })}
                          className="input" format={`h:mm a`} use12Hours inputReadOnly />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Event Date/Time End *</label>
                    <div className="row">
                      <div className="col">
                        <input type="date" className="form-control input-group-field" name="birthdate" id="birthdate" value={this.state.event_dateend}
                          onChange={event => this.setState({event_dateend: event.target.value}, () => { this.handleEventDateTimeChange(); })} />
                      </div>
                      <div className="col">
                        <TimePicker showSecond={false} value={moment(this.state.event_timeend, "YYYY-MM-DD hh:mm:ss")} 
                          onChange={(e) => this.setState({event_timeend: e}, () => { this.handleEventDateTimeChange(); })}
                          className="input" format={`h:mm a`} use12Hours inputReadOnly />
                      </div>
                    </div>
                    {this.state.errors.event_datetime &&
                      <div className="form-group">
                        <div className="row">
                          <div className="col">
                            <small id="eventDateTimeError" className="form-text text-muted">{this.state.errors.event_datetime}</small>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div className="form-group">
                    <label htmlFor="eventImage">Event Images</label>
                    {this.state.eventImageEvent ? 
                      <div>
                        <div style={{backgroundImage: `url(${this.state.eventImageEventSrc}), url('/trans.png')`, marginRight: '20px', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem', backgroundSize: 'contain, auto', backgroundRepeat: 'no-repeat, repeat', backgroundPosition: 'center', float: 'left'}}></div>
                        <div style={{float: 'left'}}>
                          {this.state.eventImageEvent.name} <br/>
                          {this.state.eventImageEvent.size} <br/>
                          {this.state.eventImageEvent.type} <br/>
                          <a className="btn btn-danger btn-sm" style={{color: 'white', marginTop: '10px'}} onClick={this.removeEventImage}>Remove</a>
                        </div>
                        <div style={{clear: 'both'}}></div>
                      </div>
                      :
                      <Files name="eventImage" accepts={['image/*']} clickable className="field-drop inputClass" onError={this.handleEventImageChangeError} onChange={this.handleEventImageChange} maxFileSize={1000000}  style={{display: 'block', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}} dropActiveClassName="dropping">
                        <div className="centered"><a className="btn btn-primary">Add File</a></div>
                      </Files>
                    }
                    <small id="eventImageError" className="form-text text-muted" style={{marginBottom: '10px'}}>
                      Accepts: images/*<br/>
                      Max file size 1MB
                    </small>
                    {this.state.eventImageEventTwo ? 
                      <div>
                        <div style={{backgroundImage: `url(${this.state.eventImageEventTwoSrc}), url('/trans.png')`, marginRight: '20px', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem', backgroundSize: 'contain, auto', backgroundRepeat: 'no-repeat, repeat', backgroundPosition: 'center', float: 'left'}}></div>
                        <div style={{float: 'left'}}>
                          {this.state.eventImageEventTwo.name} <br/>
                          {this.state.eventImageEventTwo.size} <br/>
                          {this.state.eventImageEventTwo.type} <br/>
                          <a className="btn btn-danger btn-sm" style={{color: 'white', marginTop: '10px'}} onClick={this.removeEventImageTwo}>Remove</a>
                        </div>
                        <div style={{clear: 'both'}}></div>
                      </div>
                      :
                      <Files name="eventImage" accepts={['image/*']} clickable className="field-drop inputClass" onError={this.handleEventImageTwoChangeError} onChange={this.handleEventImageTwoChange} maxFileSize={1000000}  style={{display: 'block', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}} dropActiveClassName="dropping">
                        <div className="centered"><a className="btn btn-primary">Add File</a></div>
                      </Files>
                    }
                    <small id="eventImageError" className="form-text text-muted" style={{marginBottom: '10px'}}>
                      Accepts: images/*<br/>
                      Max file size 1MB
                    </small>
                    {this.state.eventImageEventThree ? 
                      <div>
                        <div style={{backgroundImage: `url(${this.state.eventImageEventThreeSrc}), url('/trans.png')`, marginRight: '20px', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem', backgroundSize: 'contain, auto', backgroundRepeat: 'no-repeat, repeat', backgroundPosition: 'center', float: 'left'}}></div>
                        <div style={{float: 'left'}}>
                          {this.state.eventImageEventThree.name} <br/>
                          {this.state.eventImageEventThree.size} <br/>
                          {this.state.eventImageEventThree.type} <br/>
                          <a className="btn btn-danger btn-sm" style={{color: 'white', marginTop: '10px'}} onClick={this.removeEventImageThree}>Remove</a>
                        </div>
                        <div style={{clear: 'both'}}></div>
                      </div>
                      :
                      <Files name="eventImage" accepts={['image/*']} clickable className="field-drop inputClass" onError={this.handleEventImageThreeChangeError} onChange={this.handleEventImageThreeChange} maxFileSize={1000000}  style={{display: 'block', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}} dropActiveClassName="dropping">
                        <div className="centered"><a className="btn btn-primary">Add File</a></div>
                      </Files>
                    }
                    <small id="eventImageError" className="form-text text-muted" style={{marginBottom: '10px'}}>
                      Accepts: images/*<br/>
                      Max file size 1MB
                    </small>
                    
                  </div>

                </form>
              </div>
            </div>
          </div>


          <div className="container-fluid">
            <hr />
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/events'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addEvent} disabled={this.props.isAddingEvent || !this.state.canAdd} >Add Event</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editEvent} disabled={this.props.isEditingEvent || !this.state.canEdit} >Edit Event</button>
                }
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  events: state.events.events,
  isLoadingEvent: state.events.isLoadingEvent,
  isAddingEvent: state.events.isAddingEvent,
  isEditingEvent: state.events.isEditingEvent,
  stores: state.stores.stores,
  isLoadingStores: state.stores.isLoadingStores,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadEvent,
      loadEvents,
      addEvent,
      editEvent,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EventEditor);


// WEBPACK FOOTER //
// ./src/modules/Events/EventEditor.js